import { render, staticRenderFns } from "./DifferentShop.vue?vue&type=template&id=0e890514"
import script from "./DifferentShop.vue?vue&type=script&lang=js"
export * from "./DifferentShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports